import { Card, Table, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { fetchMe } from '../api/me';
import { useAccessToken } from '../auth/token-context';
import { ANLAM } from '../theme';

/**
 * SSO kimlik kartı — /api/me'nin ekran yüzü (F0·S3 kabulünün taşındığı yer;
 * test kancaları me-result/me-username korunur; `sub` SATIRI S10 gezinti
 * kararıyla KALDIRILDI — teknik artık, e2e kimlik kanıtı kullanıcı adından).
 * Yalnız KİMLİK gösterir; şapka/tenant başka kartlardan gelir (kimlik ≠ yetki).
 */
export function IdentityCard(): React.JSX.Element {
  const token = useAccessToken();
  const me = useQuery({
    queryKey: ['me'],
    queryFn: ({ signal }) => fetchMe(token, signal),
  });

  if (me.isPending) return <Text size="sm">Kimlik okunuyor…</Text>;
  if (me.isError) {
    return (
      <Text size="sm" c={ANLAM.engel} role="alert">
        /api/me başarısız: {me.error instanceof Error ? me.error.message : 'bilinmeyen hata'}
      </Text>
    );
  }
  return (
    <Card withBorder padding="md" data-testid="me-result">
      <Text size="sm" fw={600} mb="xs">
        SSO kimliği
      </Text>
      <Table variant="vertical" layout="fixed" withRowBorders={false}>
        <Table.Tbody>
          <Table.Tr>
            <Table.Th w={120}>Kullanıcı</Table.Th>
            <Table.Td data-testid="me-username">{me.data.preferredUsername ?? '—'}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th>Ad</Table.Th>
            <Table.Td>{me.data.fullName ?? '—'}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th>E-posta</Table.Th>
            <Table.Td>{me.data.email ?? '—'}</Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </Card>
  );
}
